import { render } from "./ChatResourceUploadView.vue?vue&type=template&id=ba46bd4c"
import script from "./ChatResourceUploadView.vue?vue&type=script&lang=js"
export * from "./ChatResourceUploadView.vue?vue&type=script&lang=js"

import "./ChatResourceUploadView.vue?vue&type=style&index=0&id=ba46bd4c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__